import { Navigate } from "react-router-dom";
import { useEmployeeSession } from "@/hooks/useEmployeeSession";
import { useMonteurT } from "@/i18n/monteur";

/**
 * Hüllt Monteur-Routen ein: wenn keine gültige Session vorhanden → /monteur/login.
 *
 * Während der initiale `loading`-State läuft (Cookie-Validierung gegen
 * /auth/me), zeigen wir eine schmale Lade-Anzeige statt Redirect, sonst
 * flackert die Seite kurz auf die Login-Page bevor sie zurückspringt.
 *
 * AUTH-SICHERHEIT V2 · Phase 2 (Feb 2026): Session-Marker ist ab jetzt
 * `session.employee?.id` (Metadaten-Feld), nicht mehr `session.token` — der
 * Auth-Token liegt im httpOnly-Cookie.
 */
export default function ProtectedMonteurRoute({ children }) {
  const { session, loading } = useEmployeeSession();
  const t = useMonteurT();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
        {t("common.loading")}
      </div>
    );
  }
  if (!session?.employee?.id) {
    return <Navigate to="/monteur/login" replace />;
  }
  return children;
}
